module.exports = __webpack_public_path__ + "img/us-ak.186c09d6.svg";